import React from 'react';
import MetricHelpIcon from './MetricHelpIcon';

const DashboardMetricLabel = ({ children, helpText, className = 'text-muted small' }) => (
  <span className={`dashboard-metric-label d-inline-flex align-items-center gap-1 ${className}`.trim()}>
    <span>{children}</span>
    <MetricHelpIcon text={helpText} id={`label-${children}`} />
  </span>
);

export default DashboardMetricLabel;
